import { get, post, put } from "./base";

export const ERROR_MESSAGES = {
  FORBIDDEN: "You don't have permission to perform this action",
  GENERIC: "An error occurred while processing your request",
};

export async function getComments(deviceId) {
  const response = await get(`comments/${deviceId}`);
  if (!response.ok) {
    throw new Error("Failed to fetch comments");
  }
  const responseData = await response.json();
  return responseData.data || [];
}

export async function addComment(deviceId, text, isPublic = true) {
  const response = await post(`comments/${deviceId}`, {
    comment: {
      text,
      is_public: isPublic,
      device_id: deviceId,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to add comment");
  }
  return await response.json();
}

export async function getCommentCount(deviceId) {
  const response = await get(`comments/${deviceId}/count`);
  if (!response.ok) {
    throw new Error("Failed to fetch comment count");
  }
  const data = await response.json();
  return data.count || 0;
}

export async function hideComment(commentId) {
  const response = await put(`comments/${commentId}/hide`);
  if (!response.ok) {
    throw new Error("Failed to hide comment");
  }
  return await response.json();
}
